import { toDate } from '@a2system/angular';
import { Injectable, Optional } from '@angular/core';
import { Firestore, collectionData, collection, setDoc, doc, docData ,DocumentReference, query, limit, WithFieldValue, DocumentData, QueryDocumentSnapshot, SnapshotOptions, updateDoc, arrayUnion, QueryConstraint, where } from '@angular/fire/firestore';
import {  Observable } from 'rxjs';

import { UserModel } from '../models/user.model';

@Injectable({
  providedIn: 'root'
})
export class UserDbService {
  collectionName = 'users';
  collection;
  constructor(
    @Optional() private firestore: Firestore
  ) {
    if (this.firestore){
      this.collection = collection(this.firestore, this.collectionName);
    }
  }

  userConverter = {
    toFirestore(user: WithFieldValue<UserModel>): DocumentData {
      return user;
    },
    fromFirestore(
      snapshot: QueryDocumentSnapshot,
      options: SnapshotOptions
    ): UserModel {
      const data = snapshot.data(options)!;
      data.createdAt = toDate(data.createdAt);
      data.updatedAt = toDate(data.updatedAt);
      return data as UserModel;
    }
  }

  set(user:UserModel):Promise<any>{
    const {id, ...data} = user;
    return this.firestore
      ? setDoc(doc(this.firestore, 'users', id), data)
      : Promise.reject()
  }

  updateFinalWindow(id, windowId):Promise<any>{
    const docRef = doc(this.firestore, 'users', id)
    return updateDoc(docRef, {
      finalWindows: arrayUnion(windowId)
    })
  }

  get$(id:string): Observable<UserModel> {
    const docRef = doc(this.firestore, 'users', id).withConverter(this.userConverter);
    return docData(docRef) as Observable<UserModel>;
    // return docData(docRef, {idField:'id'}) as Observable<UserModel>;
  }

  getAll$():Observable<UserModel[]> {
    const _query = query(this.collection, limit(100)).withConverter(this.userConverter)
    return collectionData(_query, {idField:'id'}) as Observable<UserModel[]>;
  }

  getByRole$(role):Observable<any[]>{
    let _where: QueryConstraint[] = [];
    _where.push(where('roles', 'array-contains', role));
    const _query = query(this.collection, ..._where);
    return collectionData<DocumentData, 'id'>(_query, { idField: 'id' })    
  }

}
